import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { IAccountFlagsStore } from '@/store/pinia/AccountFlagsStore.ts'
import { useCheckUser } from '@/composables/users/checkUser.ts'
import { toKebabCase } from '@/utilities.ts'
import { IUserStore } from '@/store/pinia/UserStore.ts'
import { ISessionStore } from '@/store/pinia/SessionStore.ts'
import { checkAcknowledgedFlags } from './useAccountFlagCheck'

export const adviceRouteGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
  userStore: IUserStore,
  accountFlagsStore: IAccountFlagsStore,
  sessionStore: ISessionStore,
): Promise<void> => {
  const { isUser } = useCheckUser()
  const userData = userStore.getUser
  const routerName = to.name as string

  // not sure if the flags should be loaded here anymore, but keeping it for now
  const flags = accountFlagsStore.accountFlags
  if (!flags || !checkAcknowledgedFlags(flags)) {
    await accountFlagsStore.fetchAccountFlags()
  }

  const validUser = !!userData?.auth0id && isUser()
  const consentNeeded = !userData?.has_consented
  const isCallcentrePortal = !!sessionStore.getWhitelabelData?.callcentre_portal

  const shouldRedirectToClientDisclaimer = validUser && consentNeeded && isCallcentrePortal

  if (shouldRedirectToClientDisclaimer) {
    // @TODO check only for guidance team created clients
    next({ name: 'clientDisclaimer', params: { adviceTargetName: toKebabCase(routerName) } })
    return
  }
  next()
}
